import { connect } from 'react-redux'

import {
  getServices,
} from 'reduxpath/ducks/Service/List'

import {
  getFormats,
} from 'reduxpath/ducks/Format/List'

import {
  setDeleteModalOpen,
  setSelectedServiceId,
  removeService,
} from 'reduxpath/ducks/Service/Remove'

import {
  setIsDeleteSubCategoryModalOpen,
  setSelectedFormatId,
  removeFormat,
} from 'reduxpath/ducks/Format/Remove'

import {
  setDialogAlertOpen,
  setAlertMessage,
} from 'reduxpath/ducks/DialogAlert'

import List from './units'

const mapStateToProps = (state, ownProps) => {
  const isLoading = state.ProductTypeList.isLoading ||
    state.ProductTypeAdd.isLoading ||
    state.ProductTypeEdit.isLoading ||
    state.ServiceList.isLoading ||
    state.ServiceAdd.isLoading ||
    state.ServiceEdit.isLoading ||
    state.ServiceRemove.isLoading ||
    state.FormatList.isLoading ||
    state.FormatAdd.isLoading ||
    state.FormatEdit.isLoading ||
    state.FormatRemove.isLoading

  let alertMessage = "By deleting the Category, You'll no longer can see it on the platform."
  if (state.FormatRemove.selectedFormatId) {
    alertMessage = "By deleting the Sub Category, You'll no longer can see it on the platform."
  }

  return {
    ...ownProps,
    isLoading,
    isDeleteConfirmOpen:
      state.ServiceRemove.isDeleteCategoryModalOpen ||
      state.FormatRemove.isDeleteSubCategoryModalOpen,
    serviceWillBeDelete: state.ServiceRemove.selectedServiceId,
    formatWillBeDelete: state.FormatRemove.selectedFormatId,
    alertMessage,
    isDialogAlertOpen: state.DialogAlert.isDialogAlertOpen,
    alertMessageDialog: state.DialogAlert.alertMessage,
  }
}

const mapDispatchToProps = dispatch => ({
  setDeleteModalOpen(data) {
    return () => {
      dispatch(setDeleteModalOpen(data))
      dispatch(setIsDeleteSubCategoryModalOpen(data))
      dispatch(setSelectedServiceId(''))
      dispatch(setSelectedFormatId(''))
    }
  },

  onConfirmDelete(serviceWillBeDelete, formatWillBeDelete) {
    return () => {
      if (serviceWillBeDelete) {
        dispatch(setDeleteModalOpen(false))
        dispatch(removeService(serviceWillBeDelete, (res) => {
          if (res) {
            dispatch(setAlertMessage("Can't be deleted, this category related with sub-category, product or order"))
            return dispatch(setDialogAlertOpen(true))
          }
          const qs = {
            sort: 'createdAt ASC',
            limit: 10,
            skip: 0,
          }
          dispatch(setAlertMessage('Successfully Delete Category'))
          dispatch(setDialogAlertOpen(true))
          return dispatch(getServices(qs))
        }))
      } else {
        dispatch(setIsDeleteSubCategoryModalOpen(false))
        dispatch(removeFormat(formatWillBeDelete, (res) => {
          if (res) {
            dispatch(setAlertMessage("Can't be deleted, this category related with product or order"))
            return dispatch(setDialogAlertOpen(true))
          }
          const qs = {
            sort: 'createdAt ASC',
            limit: 10,
            skip: 0,
          }
          dispatch(setAlertMessage('Successfully Delete Sub Category'))
          dispatch(setDialogAlertOpen(true))
          return dispatch(getFormats(qs))
        }))
      }
    }
  },

  setDialogAlert(data) {
    return () => {
      dispatch(setDialogAlertOpen(data))
    }
  },
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onConfirmDelete: dispatchProps.onConfirmDelete(
    stateProps.serviceWillBeDelete,
    stateProps.formatWillBeDelete,
  ),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(List)
